// extracted by mini-css-extract-plugin
module.exports = {"SwitchAccount":"SwitchAccount_SwitchAccount__21M3R"};